import { render, staticRenderFns } from "./QuickLink.vue?vue&type=template&id=01283fc2&scoped=true&"
import script from "./QuickLink.vue?vue&type=script&lang=js&"
export * from "./QuickLink.vue?vue&type=script&lang=js&"
import style0 from "./QuickLink.vue?vue&type=style&index=0&id=01283fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01283fc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01283fc2')) {
      api.createRecord('01283fc2', component.options)
    } else {
      api.reload('01283fc2', component.options)
    }
    module.hot.accept("./QuickLink.vue?vue&type=template&id=01283fc2&scoped=true&", function () {
      api.rerender('01283fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/AboutUs/Team/QuickLink.vue"
export default component.exports